export enum TomadoresTransportadoraTypes {
  'LOAD_REQUEST' = '@tomadoresTransportadora/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@tomadoresTransportadora/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@tomadoresTransportadora/LOAD_FAILURE',

  'CLEAN_MOVIENTRADA' = '@tomadoresTransportadora/CLEAN_MOVIENTRADA',
}
export interface ITomadoresTransportadora {
  codParc: number;
  nome: string;
  cnpjCpf: string;
  codCidade: number;
  inscricaoEstadual: string;
  tipoPessoa: string;
}

export interface TomadoresTransportadoraState {
  readonly data: ITomadoresTransportadora[];
  readonly loading: boolean;
  readonly error: boolean;
}
